import React from 'react';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, helperText, error, className = '', ...props }, ref) => {
    const hasError = Boolean(error);

    if (!label) {
      // Simple checkbox without label
      return (
        <input
          ref={ref}
          type="checkbox"
          className={`h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded ${className}`}
          {...props}
        />
      );
    }

    // Checkbox with label
    return (
      <div>
        <label className="flex items-start">
          <input
            ref={ref}
            type="checkbox"
            className={`h-4 w-4 mt-1 text-primary-600 focus:ring-primary-500 border-gray-300 rounded ${className}`}
            {...props}
          />
          <span className="ml-2 text-sm text-gray-700">{label}</span>
        </label>
        {(error || helperText) && (
          <p className={`mt-1 ml-6 text-xs ${hasError ? 'text-red-600' : 'text-gray-500'}`}>
            {error || helperText}
          </p>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
